import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import  {
    GET_UING_SUCCESS,
    GET_UING_FAILED,
    GET_UING_REQUEST,
    GET_UING_CSV_REQUEST,
    GET_UING_CSV_SUCCESS,
    GET_UING_CSV_FAILED
} from "../Actions/UserInfoNGActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

// export function* GetUserInfoNGSaga(action: any): unknown {

//     console.log("hellooooooo")
//     try {
//         console.log("Using fake data:", fakeData);
//         const {values} = action.payload.values
//         const {time_frame} = action.payload.time_frame
//         const {type} = action.payload.type
//         const response = yield call(axios.post,'cTarget',action.payload,{
//                     headers: { "Content-Type": "multipart/form-data" },
//                   });
//         const response = yield call(axios.get, `getUserInfoNG?values=${Data.values}&time_frame=${Data.time_frame}&type=${Data.type}`);

//         yield put({ type: GET_UING_SUCCESS, payload: response.data });
//     } catch (error: any) {
//         if (error.response && error.response.status === 500) {
//             yield put({
//                 type: TOAST_SHOW,
//                 payload: { message: 'No Data found', severity: 'Danger', show: true },
//             });
//         } else {
//             yield put({
//                 type: TOAST_SHOW,
//                 payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
//             });
//         }
//         yield put({ type: GET_UING_FAILED });
//     }
// }

export function* GetUserInfoNGSaga(action:any):unknown {
    try {
        const response = yield call(axios.post,'getUserInfoNG',action.payload,{timeout:300000});
        const { data, status } = response;

        if (status === 200) {
            if (data && Object.keys(data).length > 0 && data.userData && data.userData.length > 0) {
                yield put({type: GET_UING_SUCCESS, payload: data});
            } else {
                throw new Error('NO_DATA');
            }
        }
    } catch (error: any) {
        yield put({type: GET_UING_FAILED});
        
        if (error.message === 'NO_DATA' || (error.response && error.response.status === 500)) {
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'No results found.', severity: 'Primary', show: true },
            });
        } else {
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
            });
        }
    }
}



export function* GetUserInfoNGCSVSaga(action: any): unknown {

    try {
        const response = yield call(axios.post, `getUserInfoNGCSV`, action.payload);
        const { 
            data,
            status
        } = response
        if(status ===200){
            yield put({type:GET_UING_CSV_SUCCESS,payload:data})
            // yield put({type:TOAST_SHOW,payload:{ message: 'User Info added successfully', severity: 'Success', show: true }})
        }
    } catch (error: any) {
        yield put({type:GET_UING_CSV_FAILED})
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}